"use strict";

export default {
  EINFACHAUSWAHL: "1b3e6ff8-861b-4f6a-87eb-a13ced1b15ac",
  MEHRFACHAUSWAHL: "d44ccfdb-2313-4be7-aa09-0bb06d2555c2"
};
